import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Menu, MenuItem } from '@blueprintjs/core';

import { copyToClipboard } from '@f/utils/clipboard';

export default class MoleculeToolbox extends PureComponent {
  static propTypes = {
    smiles: PropTypes.string,
    mol: PropTypes.object,
    onRedraw: PropTypes.func,
  };

  static defaultProps = {
    onRedraw: () => {},
  };

  onCopySmilesToClipboard = async event => {
    event.stopPropagation();
    const { smiles } = this.props;
    await copyToClipboard(smiles);
  };

  onRedraw = event => {
    event.stopPropagation();
    const { mol } = this.props;
    this.props.onRedraw(mol);
  };

  render() {
    return (
      <Menu>
        <MenuItem icon="duplicate" onClick={this.onCopySmilesToClipboard} text="Copy SMILES" />
        <MenuItem icon="refresh" onClick={this.onRedraw} text="Redraw" />
      </Menu>
    );
  }
}
